import React, { useEffect, useState } from 'react';
import { Collapse, Flex, Icon, List, ListItem } from '@chakra-ui/react';
import { Link, useLocation } from 'react-router-dom';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import { routes } from '../../../routes';
import { useSelector } from 'react-redux';

const MenuItem = ({ item, onClose }) => {
  const Component = item.items && item.items.length ? MultiLevel : SingleLevel;
  return <Component item={item} onClose={onClose} />;
};

const SingleLevel = ({ item, onClose }) => {
  return (
    <ListItem>
      <Link key={item.name} to={item.to} onClick={onClose} data-testid='side-bar-link' style={{ textDecoration: 'none' }} >
        <Flex align='center' pt='2' ml='6' mb='4' borderRadius='lg'>
          <Icon mr='4' fontSize='16' _groupHover={{ color: 'white' }} as={item.icon} />
          {item.title}
        </Flex>
      </Link>
    </ListItem>
  );
};

const MultiLevel = ({ item, onClose }) => {
  const { items: children } = item;
  const location = useLocation();

  const hasActiveChild = (items) => {
    return items.some(child => {
      if (child.to === location.pathname) return true;
      if (child.items) return hasActiveChild(child.items);
      return false;
    });
  }

  const [open, setOpen] = useState(hasActiveChild(children));

  useEffect(() => {
    if (hasActiveChild(children)) {
      setOpen(true);
    }
  }, [location.pathname, children]);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      <ListItem>
        <Flex align='center' pt='2' ml='6' mb='4' borderRadius='lg' onClick={handleClick}>
          <Icon mr='4' fontSize='16' _groupHover={{ color: 'white' }} as={item.icon} />
          {item.title}
          <Icon ml='4' fontSize='16' _groupHover={{ color: 'white' }} as={open ? MdExpandLess : MdExpandMore} />
        </Flex>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List ml='4' component="div">
          {children.map((child, key) => (
            <MenuItem key={key} item={child} onClose={onClose} />
          ))}
        </List>
      </Collapse>
    </>
  );
};

function SidebarMenu({ onClose, mode = 'top' }) {
  const user = useSelector(state => state.userState.user);
  const [filteredRoutes, setFilteredRoutes] = useState([]);

  useEffect(() => {
    if (user) {
      setFilteredRoutes(routes.filter(r => r.placement === mode));
    }
  }, [user, mode]);

  return (
    <List>
      {filteredRoutes.map((item, key) => <MenuItem key={key} item={item} onClose={onClose} />)}
    </List>
  );
}
export default SidebarMenu;
